__webpack_require__.p = "https://images-cdn-staging.curipod.com/d-cfb8c80f/_next/";